// extracted by mini-css-extract-plugin
export default {"animated-child":"y5XEAKvMMlQ_8AMY8Gq1","animatedChild":"y5XEAKvMMlQ_8AMY8Gq1","appear":"glX2eX56JyMzNjDxehUn"};